import React from 'react';

import { BaseMotionTokenTable, type MotionTokenTableValue } from '../base-table';

const values: MotionTokenTableValue[] = [
	{
		tokenName: 'motion.easing.out.bold',
		useFor: 'Use (decelerate in) to grab attention with a fast start and controlled landing',
	},
	{
		tokenName: 'motion.easing.in.practical',
		useFor: "Use (accelerate out) to get out of the user's way quickly",
	},
	{
		tokenName: 'motion.easing.inout.bold',
		useFor: 'Use for repositioning or scaling to maintain a sense of intentional energy',
	},
];

/**
 * __Easing table__
 */
export const MotionEasingTable = (): React.JSX.Element => {
	return <BaseMotionTokenTable values={values} testId="motion-duration-transition-table" />;
};
